import type { InputHTMLAttributes } from 'react'

type EmailInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'value' | 'onChange'
> & {
  value: string
  /** Called with the trimmed value on every change (typing and paste alike). */
  onValueChange: (value: string) => void
}

/**
 * Email input that trims surrounding whitespace on entry (a pasted " a@b.com "
 * is stored as "a@b.com"). Validate the value with `isValidEmail`
 * (utils/validators.ts). Shared by the manual eligibility form, the
 * doctor/clinic forms, and the invite dialog. All other input props (id,
 * className, placeholder, autoFocus, …) pass straight through.
 */
export default function EmailInput({ value, onValueChange, ...rest }: EmailInputProps) {
  return (
    <input
      {...rest}
      type="email"
      value={value}
      onChange={e => onValueChange(e.target.value.trim())}
    />
  )
}
